import { createSelector } from 'reselect';
import { AppState } from '../..';
import { AvailableType } from './models';

const selectIncidentReport = (state: AppState) => state.incidentReport;

export const selectUserChoices = createSelector(
  selectIncidentReport,
  (incidentReport) => ({
    latitude: incidentReport.latitude,
    longitude: incidentReport.longitude,
    type: incidentReport.type,
  }),
);

export const selectIncidentDetails = createSelector(
  selectIncidentReport,
  (incidentReport) => ({
    type: incidentReport.type,
    tags: incidentReport.tags,
    incidentDateTime: incidentReport.incidentDateTime,
  }),
);

export const selectIncidentDescription = createSelector(
  selectIncidentReport,
  (incidentReport) => ({
    vesselRegistration: incidentReport.vesselRegistration,
    description: incidentReport.description,
    videoUploads: incidentReport.videoUploads,
    imageUrls: incidentReport.imageUrls,
    offlineInitiated: incidentReport.offlineInitiated,
  }),
);

export const selectAvailableTypes = createSelector(
  selectIncidentReport,
  (incidentReport) => {
    const selectedArea = incidentReport.selectedArea || 'OTHER';
    const availableTypes = Object.entries(incidentReport.availableTypes)
      .filter(
        ([_key, value]: [key: string, value: AvailableType]) =>
          !value.areaKeys ||
          (value.areaKeys && value.areaKeys.includes(selectedArea)),
      )
      .map(([_key, value]: [key: string, value: AvailableType]) => {
        const availableTags = value.availableTags.filter(
          (x) => x.areaKeys && x.areaKeys.includes(selectedArea),
        );
        return [
          _key,
          {
            ...value,
            ...{ availableTags: [] },
            availableTags,
          },
        ] as [key: string, value: AvailableType];
      });
    return Object.fromEntries(availableTypes);
  },
);

export const selectSelectedTypeKey = (state: AppState) =>
  state.incidentReport.type;

export const selectSelectedType = createSelector(
  selectIncidentReport,
  selectAvailableTypes,
  (incidentReport, availableTypes) => availableTypes[incidentReport.type || ''],
);
